export default __webpack_public_path__ + "static/media/oab-caragua-logo.d65c1eb0.jpg";